import { AlphanumericValidationType } from '@polyai/stream/store/reducers/entities/types';
import type { OptionsType } from '@polyai/ui/components/molecules/Filter/Filter.constants';

import { generateTimeOptions } from 'screens/FlowDetails/helpers';

export const ALPHANUMERIC_VALIDATION_OPTIONS: OptionsType[] = [
  {
    value: AlphanumericValidationType.ZIP_CODE,
    label: 'Zip code (US)',
  },
  {
    value: AlphanumericValidationType.POSTAL_CODE,
    label: 'Postal code (UK)',
  },
  {
    value: AlphanumericValidationType.CUSTOM,
    label: 'Custom regular expression',
  },
];

export const TIME_CONFIG_OPTIONS: OptionsType[] = generateTimeOptions();
